module.exports = __webpack_public_path__ + "static/media/29BDOS25.a9640f17.jpg";